import { useLazyQuery } from "react-apollo"

import GET_PROGRAM_NAMES from "../queries/kitStatus/getProgramNames"

const useProgramNames = (options = {}) => {
  return useLazyQuery(GET_PROGRAM_NAMES(options?.variables), options)
}

export default useProgramNames
